var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#080817",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44 9.754l1.564-.901.222.363 5.8-3.35-.427-.253-.428-.236-.205-.127L6.5 10.719v.236L9.218 9.39zm0 3.444l4.55-2.623.205.365 5.817-3.352-.426-.253-.427-.236-.207-.127L6.5 14.146v.253l2.718-1.564zm0 1.722l6.036-3.49.205.363 5.817-3.35-.426-.238-.43-.254-.204-.126L6.5 15.87v.25l2.718-1.578zm0 1.708l7.568-4.363.208.366 5.768-3.335-.429-.239-.426-.25-.205-.113L6.5 17.593v.236l2.718-1.564zm0 1.722l9.054-5.23.207.38 5.769-3.334-.43-.254-.408-.238-.222-.125L6.5 19.315v.236l2.718-1.564zm15.675-7.821l-.22-.127L6.5 21.037v.236l2.718-1.564.222.363 9.054-5.23.207.364 6.73-3.871v-.616zM7.67 22.318l1.517-.87.221.364 9.04-5.23.22.377 6.764-3.919v-1.216L7.465 22.192zm10.778-4.014l.22.38 6.764-3.92v-1.217L8.95 23.06l.204.127 1.55-.901.219.363m-.282 1.391l1.564-.9.204.38 6.04-3.494.218.363 6.765-3.902v-1.232l-14.998 8.659zm1.501.853l1.549-.884.204.363 4.553-2.624.22.363 6.764-3.902v-1.233L11.92 24.783zm1.264.743l.221.127 1.55-.902.204.38 3.067-1.77.22.365 6.764-3.905V18.7zm1.707.979l1.55-.884.219.363 1.566-.916.22.38 6.764-3.905v-1.232l-10.526 6.085zm3.413-19.896l-.426-.236-.427-.254-.221-.126L6.5 12.44v.236l2.718-1.564.222.363 3.064-1.768.208.363z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRen);
export default __webpack_public_path__ + "static/media/ren.7de2a1e0fd1d1d972b7c1e551b3c3d31.svg";
export { ForwardRef as ReactComponent };